// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"NQ","tooltipWrapper":"OQ","icon":"PQ","tooltip":"QQ","content":"RQ"};